import React from 'react';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import I18n from 'i18n-js';
import ShieldIcon from '@reverbdotcom/cadence/images/brand/protection-orange.svg';
import HelpCard from '../discovery/help_card';
import { useHelpCenterArticleUrl } from '@reverbdotcom/commons/src/url_helpers';
import { PREVIOUS_YEAR_TAX_REPORTING_REQUIREMENTS_ARTICLE_ID } from './tax_profile_helpers';

export function TaxProfileFooter() {
  const previousYearReportingArticleUrl = useHelpCenterArticleUrl(PREVIOUS_YEAR_TAX_REPORTING_REQUIREMENTS_ARTICLE_ID);
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const prevYear = currentYear - 1;

  return (
    <div className="pt-10 mobile-mb-4">
      <HelpCard
        svgIcon={ShieldIcon}
        iconAlt={I18n.t('discovery.taxProfile.footer.shieldAlt')}
      >
        <p className="weight-bold">
          <Translate
            text="discovery.taxProfile.footer.doINeedToProvideInfoHeader"
          />
        </p>
        <Translate
          tag="p"
          text="discovery.taxProfile.footer.doINeedToProvideInfoParagraph1"
          args={{ previousYear: prevYear.toString() }}
        >
          <a href={previousYearReportingArticleUrl} className="text-link">
            <Translate
              text="discovery.taxProfile.footer.doINeedToProvideInfoLearnMore1"
              args={{ previousYear: prevYear.toString() }}
            />
          </a>
        </Translate>
        <Translate
          tag="p"
          text="discovery.taxProfile.footer.doINeedToProvideInfoParagraph2"
        />
      </HelpCard>
    </div>
  );
}

export default TaxProfileFooter;
